import { Routes } from '@/routes';

export default {
	'forms.index': () => import('@/modules/forms/index'),
	'forms.new': () => import('@/modules/forms/form'),
	'forms.settings': () => import('@/modules/forms/form'),
	'forms.continue': () => import('@/modules/forms/form'),
} as Routes;
